import Splide from '@splidejs/splide';

const initializeDoctorCredentials = function() {
    const sliders = document.querySelectorAll('.doctor-credentials__slider.splide');

    sliders.forEach(function(slider) {
        if (slider.classList.contains('is-initialized')) {
            return;
        }

        const options = JSON.parse(slider.getAttribute('data-splide'));
        const splide = new Splide(slider, options);
        splide.mount();
    });
};

document.addEventListener('DOMContentLoaded', function() {
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=doctor-credentials', initializeDoctorCredentials);
    } else {
        initializeDoctorCredentials();
    }
});
